import { defineCustomElements } from "wc-datepicker/dist/loader";
import generateDatePicker from "src/decidim/datepicker/generate_datepicker";
import generateTimePicker from "src/decidim/datepicker/generate_timepicker";
import { formatInputDate, formatInputTime } from "src/decidim/datepicker/datepicker_functions";
import { getDictionary } from "src/decidim/i18n";
export default function formDatePicker(input) {
  const i18nDate = getDictionary("date.formats");
  const i18nDateHelp = getDictionary("date.formats.help");
  const i18nTime = getDictionary("time");
  const i18nTimeHelp = getDictionary("time.formats.help");
  const formats = { order: i18nDate.order, separator: i18nDate.separator, time: i18nTime.clock_format || 24 };
  if (!customElements.get("wc-datepicker")) {
    defineCustomElements();
  }
  if (!input.id) {
    input.id = "demo-datepicker";
  }
  input.style.display = "none";
  const label = input.closest("label");
  const row = document.createElement("div");
  row.setAttribute("id", `${input.id}_datepicker_row`);
  row.setAttribute("class", "datepicker__datepicker-row");
  const datepickerDateColumnWrapper = document.createElement("div");
  datepickerDateColumnWrapper.setAttribute("id", `${input.id}_date-column-wrapper`);
  datepickerDateColumnWrapper.setAttribute("class", "datepicker__date-column-wrapper");
  row.append(datepickerDateColumnWrapper);
  if (label) {
    label.classList.add("datepicker__input-label");
    label.parentElement.appendChild(row);
    datepickerDateColumnWrapper.insertBefore(label, datepickerDateColumnWrapper.firstChild);
  } else {
    input.after(row);
  }
  const datepickerContainer = generateDatePicker(input, datepickerDateColumnWrapper, formats);
  const form = datepickerContainer.closest("form");
  const isAbideForm = form && form.dataset.abide === "true";
  if (isAbideForm) {
    datepickerContainer.addEventListener("click", (event) => {
      if (!event.target.classList.contains("datepicker__pick-calendar")) {
        return;
      }
      const input2 = row.querySelector("input");
      input2.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  if (input.type === "datetime-local") {
    const datepickerTimeColumnWrapper = document.createElement("div");
    datepickerTimeColumnWrapper.setAttribute("id", `${input.id}_time-column-wrapper`);
    datepickerTimeColumnWrapper.setAttribute("class", "datepicker__time-column-wrapper");
    row.append(datepickerTimeColumnWrapper);
    const timepickerContainer = generateTimePicker(input, datepickerTimeColumnWrapper, formats);
    if (!input.getAttribute("hide_help")) {
      const timeHelpTextContainer = document.createElement("div");
      timeHelpTextContainer.setAttribute("class", "datepicker__help-text-container flex gap-[0.5rem]");
      const helpTextTime = document.createElement("span");
      helpTextTime.setAttribute("class", "help-text datepicker__help-time");
      helpTextTime.innerText = i18nTimeHelp.time_format;
      timeHelpTextContainer.appendChild(helpTextTime);
      datepickerTimeColumnWrapper.insertBefore(timeHelpTextContainer, datepickerTimeColumnWrapper.firstElementChild.nextElementSibling);
    }
    if (isAbideForm) {
      timepickerContainer.addEventListener("click", (event) => {
        if (!["datepicker__select-clock", "datepicker__reset-clock"].some((className) => event.target.classList.contains(className))) {
          return;
        }
        const input2 = timepickerContainer.closest(".datepicker__time-column").querySelector("input");
        input2.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }
  if (!input.getAttribute("hide_help")) {
    const dateHelpTextContainer = document.createElement("div");
    dateHelpTextContainer.setAttribute("class", "datepicker__help-text-container flex gap-[0.5rem]");
    const helpTextDate = document.createElement("span");
    helpTextDate.setAttribute("class", "help-text datepicker__help-date");
    helpTextDate.innerText = i18nDateHelp.date_format;
    dateHelpTextContainer.appendChild(helpTextDate);
    datepickerDateColumnWrapper.insertBefore(dateHelpTextContainer, datepickerDateColumnWrapper.firstElementChild.nextElementSibling);
  }
  if (formats.time === 12) {
    document.getElementById(`period_am_${input.id}`).checked = true;
  }
  if (isAbideForm) {
    $(form).foundation("_reflow", "abide");
  }
  updateDateTimeInputs(input);
  input.parentElement.querySelectorAll(".form-error").forEach((error) => {
    const datepickerRow = document.getElementById(`${input.id}_datepicker_row`);
    const datepickerDateColumn = datepickerRow.querySelector(".datepicker__date-column");
    const datepickerTimeColumn = datepickerRow.querySelector(".datepicker__time-column");
    if (datepickerDateColumn) {
      const datepickerError = error.cloneNode(true);
      datepickerError.setAttribute("data-form-error-for", datepickerDateColumn.querySelector("input").id);
      datepickerDateColumn.parentElement.append(datepickerError);
    }
    if (datepickerTimeColumn) {
      const timepickerError = error.cloneNode(true);
      timepickerError.setAttribute("data-form-error-for", datepickerTimeColumn.querySelector("input").id);
      datepickerTimeColumn.parentElement.append(timepickerError);
    }
    error.remove();
  });
  document.addEventListener("updateDatePickerInputs", (event) => {
    const input2 = event.target.detail;
    if (input2) {
      updateDateTimeInputs(input2);
    }
  });
  function updateDateTimeInputs(input2) {
    const inputField = document.getElementById(`${input2.id}`);
    const inputFieldValue = inputField.value;
    if (inputFieldValue !== "") {
      if (input2.type === "datetime-local") {
        const dateTimeValue = inputFieldValue.split("T");
        const date = dateTimeValue[0];
        const time = dateTimeValue[1];
        document.getElementById(`${input2.id}_date`).value = formatInputDate(date, formats, input2);
        document.getElementById(`${input2.id}_time`).value = formatInputTime(time, formats.time, input2);
      } else if (input2.type === "date") {
        const dateInput = document.getElementById(`${input2.id}_date`);
        dateInput.value = formatInputDate(inputFieldValue, formats, input2);
      }
    }
  }
}
